export enum OfferType {
  MGM = 'MGM',
  LINK = 'LINK',
  IFRAME = 'IFRAME',
  ORANGE = 'ORANGE',
  WYBIERAK = 'WYBIERAK',
  DOBRY_PRAD = 'DOBRY_PRAD',
  PHONE = 'PHONE',
}
